// extracted by mini-css-extract-plugin
module.exports = {"attribute":"Attributes_attribute__2aPao","attributesContainer":"Attributes_attributesContainer__147cU"};